import { useState } from "react";
import { Plus, Robot, X } from "@phosphor-icons/react";
import { AssistantChat } from "./AssistantChat";

export function AssistantPopover() {
  const [open, setOpen] = useState(false);
  const [chatKey, setChatKey] = useState(0);

  return (
    <>
      <button
        onClick={() => setOpen((v) => !v)}
        className="fixed bottom-5 right-5 z-50 flex h-13 w-13 items-center justify-center rounded-full bg-primary p-3.5 text-primary-foreground shadow-lg transition-transform hover:scale-105"
        title="Ask the assistant"
        data-testid="assistant-fab"
      >
        {open ? <X size={22} /> : <Robot size={22} />}
      </button>
      {open && (
        <div className="fixed bottom-20 right-5 z-50 flex h-[34rem] w-[24rem] flex-col overflow-hidden rounded-xl border border-stone-200 bg-white shadow-2xl sm:w-[26rem]" data-testid="assistant-popover">
          <div className="flex items-center justify-between border-b border-stone-200 bg-accent/50 px-3.5 py-2.5">
            <div className="flex items-center gap-2">
              <Robot size={17} className="text-accent-foreground" />
              <p className="text-sm font-semibold text-stone-900">Assistant</p>
            </div>
            <div className="flex items-center gap-1">
              <button onClick={() => { localStorage.removeItem("assistant_sid"); setChatKey((k) => k + 1); }}
                className="rounded p-1 text-stone-400 hover:bg-white hover:text-stone-700" title="New chat" data-testid="assistant-popover-new">
                <Plus size={16} />
              </button>
              <button onClick={() => setOpen(false)} className="rounded p-1 text-stone-400 hover:bg-white hover:text-stone-700" title="Close" data-testid="assistant-popover-close">
                <X size={16} />
              </button>
            </div>
          </div>
          <AssistantChat key={chatKey} compact />
        </div>
      )}
    </>
  );
}
